import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=6e07d10c&scoped=true&lang=html&"
import script from "./InfoIcon.vue?vue&type=script&lang=js&"
export * from "./InfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07d10c",
  null
  
)

export default component.exports